import React, { useState } from 'react';
import './DivineStore.css';

const ProductCard = ({ image, name, offerPrice, sellPrice }) => {
  const [showForm, setShowForm] = useState(false);

 return (
    <>
      <div className="product-card">
        <img src={image} alt={name} className="product-image" />
        <h3>{name}</h3>
        <p>
          <span className="offer-price">₹{offerPrice}</span>
          <span className="sell-price">₹{sellPrice}</span>
        </p>
        <button onClick={() => setShowForm(true)}>Contact Now</button>
      </div>

      {/* Centered Modal */}
      {showForm && (
        <div className="contact-form-overlay" onClick={() => setShowForm(false)}>
          <div className="contact-form-modal" onClick={(e) => e.stopPropagation()}>
            <h2>Contact Us</h2>
            <form>
              <input type="text" placeholder="Your Name" required />
              <input type="email" placeholder="Your Email" required />
              <textarea placeholder="Your Message" rows="4" required></textarea>
              <button type="submit">Send</button>
            </form>
            <button className="close-btn" onClick={() => setShowForm(false)}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};

const DivineStore = () => {

const products = [
  {
    image: '/assets/products/Product_1.png',
    name: '7 Chakra Black Beads Mala (Protection + Healing)',
    offerPrice: 1800,
    sellPrice: 1200
  },
  {
    image: '/assets/products/Product_2.png',
    name: 'Natural Emerald (Panna) – Certified Quality',
    offerPrice: 6000,
    sellPrice: 4500
  },
  {
    image: '/assets/products/Product_3.png',
    name: 'Red Sandalwood Mala (Chandan Mala)',
    // If crystal use: 'Brown Tourmaline Mala – Energy Protection'
    offerPrice: 2000,
    sellPrice: 1500
  },
  {
    image: '/assets/products/Product_4.png',
    name: '3 Mukhi Rudraksha (Certified • Powerful Healing)',
    offerPrice: 1500,
    sellPrice: 999
  },
  {
    image: '/assets/products/Product_5.png',
    name: 'Shri Yantra (Brass) – Prosperity & Energy Balancing',
    offerPrice: 2500,
    sellPrice: 1700
  },
  {
    image: '/assets/products/Product_6.png',
    name: 'Natural Agate (Akik) Stone – Energy Stability',
    offerPrice: 1200,
    sellPrice: 800
  }
];


  return (
    <div className="products-grid">
      {products.map((item, index) => (
        <ProductCard
          key={index}
          image={item.image}
          name={item.name}
          offerPrice={item.offerPrice}
          sellPrice={item.sellPrice}
        />
      ))}
    </div>
  );
};

export default DivineStore;
